import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { showTutorial } from '../tutorial.util';

export class GrowthCapsuleTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'growthCapsule';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'growthCapsulePurchase') {
      return false;
    }

    // Show tutorial popup and grant rewards
    await showTutorial('growthCapsule', {
      $stepIndex: 25,
      $stepName: 'growthCapsule',
    });

    return true;
  }
}
